import React, { useEffect, useState } from "react";

import totop from "../Assets/img/gototop.png";

const GoTop = ({ id }) => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
  const handleScroll = () => {
    if (window.scrollY > 400) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };

  // 1. Add the listener when the component loads
  window.addEventListener("scroll", handleScroll);

  // 2. THIS IS THE FIX: The cleanup function
  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);

  return (
    <>
      {showButton && (
        <a href={`#${id}`} className="back-to-top">
          <img src={totop} className="image-fluid" alt="" />
        </a>
      )}
    </>
  );
};

export default GoTop;
